import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnfrageLiveSharingComponent } from '../../features/anfrage/components/anfrage-live-sharing/anfrage-live-sharing.component';

@NgModule({
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  declarations: [
    AnfrageLiveSharingComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    AnfrageLiveSharingComponent,
  ]
})
export class CoreCustomElementWrapperModule { }
